import Big from 'big.js';

/**
 * Floatに変換（小数点は指定桁数以下は切り捨て）
 * @param {*} val 値
 * @param {*} decimalplace 少数桁数
 * @returns Float
 */
export function toFloat(val, decimalplace = 0) {
  if (val === Infinity || val === -Infinity) {
    return val;
  }
  if (isNaN(parseFloat(val))) {
    return parseFloat(0);
  }

  let v = new Big(parseFloat(val));
  return parseFloat(v.toFixed(decimalplace, 0));
}

/**
 * Intに変換（変換できない場合はnull)
 * @param {*} val 値
 * @returns Int
 */
export function toInt(val, defaultValue = null) {
  let n = parseInt(val);
  if (isNaN(n)) {
    return defaultValue;
  }
  return parseInt((val * 1).toFixed(0));
}

// 数値をアルファベットに変換(1→A、2→B、27→AA、52→AZ)
export function numberToLetters(num) {
  let result = '';
  while (num > 0) {
    // 1から26の範囲に変換するために1を引く
    num--;
    // 26で割った余りで文字を決定し、文字列の先頭に追加
    result = String.fromCharCode((num % 26) + 65) + result;
    // 次の桁の処理のために26で割る
    num = Math.floor(num / 26);
  }
  return result;
}

/**
 * 割合計算をおこなう
 * @param {*} val1 値1（分子）
 * @param {*} val2 値2（分母）
 * @param {*} decimalplace 少数桁数
 * @returns Float
 */
export function calcRate(val1, val2, decimalplace = 0) {
  if (val1 == null || val2 == null) {
    return null;
  }
  let rate = toFloat(val1 / val2, decimalplace);
  // Infinityの場合はnull、それ以外は9.999以上は9.999にする
  return rate === Infinity ? null : rate >= 9.999 ? 9.999 : rate;
}

// 税抜き合計から消費税を計算する
export const calcTax = (zeinuki) => {
  let tax = Math.floor(zeinuki * 0.1);
  let total = zeinuki + tax;

  // 端数調整
  const lastDigit = total % 10;
  if (lastDigit === 1) tax = Math.max(0, tax - 1);

  return tax;
};

/**
 * 金額表記として有効な文字列かどうか（「サービス」「別途」など）
 */
export function isAmountText(raw) {
  if (raw === null || raw === undefined || typeof raw === 'number') {
    return false;
  }
  const s = String(raw).trim();
  if (s === '') {
    return false;
  }
  // 計算式は不可
  if (s.startsWith('=') || s.startsWith('+') || s.startsWith('＝') || s.startsWith('＋')) {
    return false;
  }
  // 全角の数字・記号を半角にし、カンマ・円記号・空白を除いてから数値かどうかを判定する
  const normalized = s
    .replace(/[０-９．，－]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0))
    .replace(/[,\s　円¥￥]/g, '');
  if (normalized === '') {
    return false;
  }
  return isNaN(Number(normalized));
}
